/**
 * Chart data view settings values
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/query/QueryExecutionStrategyType.java
 */
export const QUERY_EXECUTION_STRATEGY_TYPE = {
  AUTOMATIC: 'auto',
  ON_DEMAND: 'onDemand'
};
